import { AiOutlineArrowLeft } from 'react-icons/ai'
import { FaTrashAlt } from 'react-icons/fa'
import { BiEditAlt } from 'react-icons/bi'
import { useMenu } from '../../../context/MenuContext'
import { toast } from 'react-toastify'
import { ImSad } from 'react-icons/im'
import { api } from '../../../services/api'
import { MainLoader } from '../../../components/loaders/mainLoader'
import { formatMoney } from '../../../Utils/formatMoney'
import { EditProductQuantity } from './EditProductQuantity'
import { useEffect, useState, useMemo } from 'react'

import { Container, Header, BuyContainer } from './style'


export function CartBuyModal({ listBuying, handleSetListBuying, businessDatas }) {
    const nameBusiness = window.location.pathname.split('/')[2];
    const [isLoading, setIsLoading] = useState(false);
    const [openEdit, setOpenEdit] = useState({open: false, name: '', qtt: 1, index: null})

    const { 
        handleSetItem, 
        isBuyModalOpen, handleSetIsBuyModalOpen
    } = useMenu();

    const customId = 100;


    const total = useMemo (() => {
        return listBuying.reduce((sumTotal, product) => {
            return sumTotal + product.cost * product.addCounterProduct;
        }, 0)
    }, [listBuying])
      

    
    function handleEditProduct(name, qtt, index) {
        setOpenEdit({open: true, name, qtt, index})
    }

    function handleCloseEditProduct() {
        setOpenEdit({open: false, name: '', qtt: 1, index: null})
    }

    function handleConfirmEditProduct(index, quantity) {
        const newArray = [...listBuying]
        newArray[index].addCounterProduct = quantity

        handleSetListBuying(newArray)
        localStorage.setItem('@Inoveclube:listBuying' + window.location.pathname.split('/')[2], JSON.stringify([...newArray]))
        handleCloseEditProduct()
    }

    function handleCloseModal() {
        handleSetItem({ code: 0, show: false })
        handleSetIsBuyModalOpen(false)
    }

    function handleClearItem(index) {
        listBuying.splice(index, 1);
        listBuying.length > 0 ? localStorage.setItem('@Inoveclube:listBuying' + window.location.pathname.split('/')[2], JSON.stringify([...listBuying])) 
        : localStorage.removeItem('@Inoveclube:listBuying' + window.location.pathname.split('/')[2]);
        handleSetListBuying([...listBuying]);
    }

    async function handleGoToShoppingPage() {
        setIsLoading(true)
        try{
            const response = await api.get(`/getBusiness/${nameBusiness}/${localStorage.getItem('@Inoveclube:token')}`)
            const { isOpenBusiness, minValue } = response.data

            const minValueFormatted =  formatMoney(minValue)

            setIsLoading(false)
            
            if(minValue > 0 && total < minValue){
                toast.error(`O valor mínimo de compra neste estabelecimento é: ${minValueFormatted}`)
                
            }else{
                if(isOpenBusiness){
                    if(localStorage.getItem('@Inoveclube:listBuying' +  window.location.pathname.split('/')[2])){
                        if(localStorage.getItem('@Inoveclube:token')){ 
                            window.location.href=`${process.env.REACT_APP_URL}shopping`
                        }else{
                            localStorage.setItem('@Inoveclube:menu', true)
                            window.location.href=`${process.env.REACT_APP_URL}login`
                        }
                    }else{                        
                        toast.error('Adicione itens ao carrinho para continuar', {
                            toastId: customId
                        })
                    }
                }else{
                    toast.info("O estabelecimento encontra-se fechado no momento", {
                        toastId: customId
                    })
                }
            }
        
        }catch(error){
            setIsLoading(false)
            toast.error(error)
        }   
    }


    useEffect(() => {
        if(!isBuyModalOpen)
            handleCloseEditProduct()
    }, [isBuyModalOpen])
    

    return (

        <>
            {isBuyModalOpen ?
                <Container bgcolor={businessDatas.colorButton}>
                    <Header>
                        <AiOutlineArrowLeft onClick={() => { 
                            handleSetItem({ code: 0, show: false })
                            handleSetIsBuyModalOpen(false) 
                            }} 
                        />
                        <h1>Pedido</h1>
                    </Header>
                   
                    {listBuying.length > 0 ?
                    <div className="products-container">
                        {listBuying.map((product, index) => (
                                product.name === "" ?
                                    <></> :
                                    <BuyContainer 
                                        key={product.code} 
                                        item={product.src}
                                        editing={index === openEdit.index}
                                    >
                                        {product.src === '' ?
                                        <></> :
                                        <div className="image"></div>
                                        }
                                        <div className="align">
                                            <div className="text">
                                                <h3>{product.name} {product.sizeDescription}</h3>
                                                <div className="additional-container">
                                                    {product.listAssemblyItensSelected.length > 0 ?
                                                        product.listAssemblyItensSelected.map(element => (
                                                            element.filled ?
                                                                <span className="additional">
                                                                    {product.assembledItensFilled === 1 ? '1' : '1/' + product.assembledItensFilled} {element.name}
                                                                </span>
                                                            : <></>
                                                        ))
                                                    : 
                                                    <></>
                                                    }
                                                    {product.selectedOptions.map(element => (
                                                        <span className="additional">{element.qtd}x {element.obsDescription}</span>
                                                    )
                                                    )}
                                                    {product.textAdditional !== '' ?
                                                    <div className="additional">obs: {product.textAdditional}</div> : <></>}
                                                </div>
                                                <span className="calc">
                                                    {formatMoney(product.cost)} x {product.addCounterProduct}
                                                </span>

                                                <span className="value">
                                                    = {formatMoney(product.cost * product.addCounterProduct)}

                                                </span>
                                            </div>
                                            <div className="buttonsEditClear">
                                                <FaTrashAlt onClick={() => handleClearItem(index)} />
                                                <BiEditAlt 
                                                    onClick={() => handleEditProduct(product.name, product.addCounterProduct, index)}
                                                />
                                            </div>
                                        </div>
                                    </BuyContainer>
                        ))
                        }
                    </div>
                    : <div className="cartEmpty">
                         <h1>Nenhum produto adicionado ao carrinho</h1>
                        <ImSad />
                    </div>}

                    <EditProductQuantity 
                        openEdit={openEdit}
                        handleCloseEditProduct={handleCloseEditProduct}
                        confirmEditProduct={handleConfirmEditProduct}
                    />
                    
                    {
                        isLoading ?
                        <MainLoader title={'Organizando pedido'}/>
                        : <></>
                    }

                    <div>
                        <div className="button-container">

                            <button 
                                onClick={handleCloseModal} 
                                className="close-all"
                            >
                                Adicionar mais itens
                            </button>

                            <div className="price-end">
                                <div className="total">
                                    <span>Total</span>
                                    <p>{formatMoney(total)}
                                    </p>
                                </div>

                                <button onClick={handleGoToShoppingPage}>
                                    Continuar
                                </button>
                            </div>
                            
                        </div>
                    </div>
                </Container> : <></>
            }
        </>
    );
}
